module.exports = __webpack_public_path__ + "img/18.88.ecae60f6.png";